import { render, staticRenderFns } from "./IndustrieBonus.vue?vue&type=template&id=ea442410&"
import script from "./IndustrieBonus.vue?vue&type=script&lang=js&"
export * from "./IndustrieBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports